import { Customer_Contracts } from "data/endpoints";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import React from "react";
import ContractSimplified from "../components/ContractSimplified";
import ContractSimplifiedHeader from "../components/ContractSimplifiedHeader";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { loadDataFilterConfig } from "features/shared/helpers/modules";
import InvoiceSimulationButton from "features/invoiceSimulation/components/InvoiceSimulationButton";

const contractsDataFilterJson = loadDataFilterConfig("contractsDataFilter");

const ContractsSection = () => {
  return (
    <>
      <DataGrid
        gridId={DataGridId.contractGrid}
        url={Customer_Contracts}
        filterJson={contractsDataFilterJson}
        renderItem={(item) => <ContractSimplified contract={item} />}
        renderHeader={() => <ContractSimplifiedHeader />}
        renderGridHeaderBtns={() => <InvoiceSimulationButton />}
      />
    </>
  );
};

export default ContractsSection;
